<template>
  <div>
    <el-dialog
      :visible="visible"
      v-if="visible"
      show-close
      width="450px"
      :title="title"
      :close-on-click-modal="false"
      :before-close="cancel"
      append-to-body
      draggable
    >
      <Main
        ref="main"
        :type="type"
        :disabled="disabled"
        :subgroupCode="subgroupCode"
        :levelNo="levelNo"
        @close="close"
        @reload="$emit('reload')"
      />
      <template #footer>
        <el-button size="small" @click="cancel">
          {{ $l("INDEX.btn_cancel") || "取消" }}
        </el-button>
        <el-button size="small" v-if="!disabled" type="primary" @click="save">
          {{ $l("INDEX.btn_save") || "保存" }}
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import Main from "./Main.vue";

export default {
  components: { Main },
  props: {
    visible: Boolean,
    type: { type: String, default: "" },
    subgroupCode: { type: String, default: "" },
    levelNo: { type: Number, default: 1 },
  },
  data() {
    return {
      titleMap: {
        edit: this.$l("dialog_title_edit") || "编辑人员分组信息",
        add: this.$l("dialog_title_add") || "添加人员分组信息",
      },
    };
  },
  computed: {
    title() {
      return this.titleMap[this.type];
    },
    disabled() {
      return this.type === "detail";
    },
  },
  methods: {
    close() {
      this.$emit("close");
      this.$emit("update:visible", false);
    },
    cancel() {
      this.$refs.main.cancel();
    },
    save() {
      this.$refs.main.save();
    },
  },
};
</script>
